// extracted by mini-css-extract-plugin
export var brand = "_1l-9";
export var button = "_1l-0";
export var chevron = "_1l-v";
export var chevronButton = "_1l-w";
export var content = "_1l-n";
export var danger = "_1l-g";
export var dangerOutlined = "_1l-h";
export var dark = "_1l-l";
export var darkTheme = "_1l-c";
export var extraSmall = "_1l-4";
export var fullWidth = "_1l-8";
export var ghost = "_1l-d";
export var gray = "_1l-t";
export var icon = "_1l-p";
export var iconButton = "_1l-s";
export var iconButtonBorder = "_1l-x";
export var iconButtonBorderDark = "_1l-y";
export var iconButtonBorderLight = "_1l-z";
export var iconLeft = "_1l-q";
export var iconRight = "_1l-r";
export var large = "_1l-1";
export var light = "_1l-m";
export var medium = "_1l-2";
export var micro = "_1l-5";
export var nano = "_1l-7";
export var outlined = "_1l-k";
export var pending = "_1l-a";
export var primary = "_1l-i";
export var shadow = "_1l-o";
export var small = "_1l-3";
export var solidLight = "_1l-e";
export var solidLightBrand = "_1l-f";
export var spinner = "_1l-u";
export var transparent = "_1l-j";
export var warning = "_1l-b";
export var wideNano = "_1l-6";